import React from 'react';
import Breadcrumb from '../components/Breadcrumb';
import Impressum from '../components/Impressum';

const ImpressumPage: React.FC = () => {
  return (
    <div className="min-h-screen bg-gray-50">
      <Breadcrumb currentPage="Impressum" />
      <Impressum />
    </div>
  );
};

export default ImpressumPage; 